import React from 'react';
import { Paragraph } from 'scy/text';
import margin from 'scy/margin.mod.scss';

export default function Graf({ children }) {
  return <Paragraph marginClass={margin.bottom_sm}>{children}</Paragraph>;
}
